import { Box, Modal, Typography, Button } from "@mui/material";
import { ParentalConsentType } from "../../../__generated__/graphql";
import { LoadingButton } from "@mui/lab";
type ReturnCallback = (() => Promise<string | void> | string | void) | null | void;
export type ParentalConsentConfirmProps = {
    consentStatus: string | null | undefined,
    studentName: string | undefined,
    openModal: boolean,
    closeModal: () => void,
    onCancel: () => void,
    submitting: boolean,
    onConfirm: Callback
}
type Callback = (() => void) | null | undefined;

const buttonStyle = {
    maxWidth: "155px",
    fontSize: "12px",
    height: "40px",
    marginTop: "16px",
    color: "#000000",
    background: "#C4C4C4",
    border: "1px solid #000000",
    "&:hover": {
        backgroundColor: "#c4c4c4",
    },
};
export function ParentalConsentConfirmModal({ consentStatus, studentName, openModal, closeModal, onCancel, submitting, onConfirm }: ParentalConsentConfirmProps) {
    const consentString = consentStatus === ParentalConsentType.Rejected ? "DO NOT CONSENT" : "CONSENT"
    return (
        <Modal open={openModal} onClose={closeModal}>
            <Box component="div" sx={{
                position: "absolute" as "absolute",
                top: "50%",
                left: "50%",
                borderRadius: "10px",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                padding: "24px",
                textAlign: "center"
            }}>
                <Typography>I <strong>{consentString}</strong> to my Child's ({studentName}) participation in the futuresTHRIVE tScreen/TweenScreen™</Typography>
                <Box component="div" sx={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                    <LoadingButton
                        sx={{ ...buttonStyle, backgroundColor: "#83A47B" }}
                        loading={submitting}
                        variant="contained"
                        onClick={() => onConfirm && onConfirm()}
                    >Confirm</LoadingButton>
                    <Button
                        sx={buttonStyle}
                        color="secondary"
                        variant="contained"
                        onClick={() => onCancel}
                    >Cancel</Button>
                </Box>
            </Box>
        </Modal>
    )

}